import { IApplicationContext } from 'shared/types/applicationContext';
import { suggest } from './suggest';
import { either, isEmpty, isNil, reject } from 'ramda';
import { getGeoSuggestions } from 'shared/services/geoSuggest';
import { IResultSuggestions } from '@cian/geosuggest-widget';
import { IMultiSuggestParams } from 'shared/types/geoSuggest';

export const getMultiSuggest = async (context: IApplicationContext, params: IMultiSuggestParams) => {
  const {
    yandex: { value, options },
    structured: structuredParams,
  } = params;

  const results = await Promise.all([
    suggest(context, { request: value, options }),
    getGeoSuggestions(context, structuredParams).catch(() => null),
  ]);

  const [yandex, structured] = results;

  if (!yandex && (!structured || (structured && !structured.data.suggestions))) {
    throw new Error('Failed to load suggest data');
  }

  let suggestions: IResultSuggestions = {};
  const sortOrder: string[] = [];

  if (structured && structured.data.suggestions) {
    const { cities, districts, newbuildings, builders, undergrounds, railways, roads, villages, regionalDistricts } =
      structured.data.suggestions;

    suggestions = {
      cities: cities && cities.items,
      districts: districts && districts.items,
      newbuildings: newbuildings && newbuildings.items,
      builders: builders && builders.items,
      undergrounds: undergrounds && undergrounds.items,
      villages: villages && villages.items,
      roads: roads && roads.items,
      railways: railways && railways.items,
      regionalDistricts: regionalDistricts && regionalDistricts.items,
    } as IResultSuggestions;
  }

  suggestions = reject(either(isNil, isEmpty), suggestions);

  if (structured && !isEmpty(suggestions)) {
    sortOrder.push(...structured.data.sortOrder);
  }

  if (yandex && !isEmpty(yandex)) {
    suggestions.addresses = Object.keys(suggestions).length ? yandex.slice(0, 5) : yandex;

    if (!sortOrder.includes('addresses')) {
      sortOrder.push('addresses');
    }
  }

  return {
    suggestions,
    sortOrder,
  };
};
